export const dsoFormat = {
  dso: 150,
  billed: 55,
  unbilled: 90,
};
